import React, { forwardRef, useRef} from 'react'
import ConfirmPopup from './ConfirmPopup'
import MessageEditor from './MessageEditor'
import { Form } from 'antd'
import _ from 'lodash'
import { antiTransformComment } from 'utils/commentUtil';


export default forwardRef(function ToolConfigurationNotesPopup(props, ref) {
    const formRef = useRef(null);

    const onOkSubmit = async() =>{
        if (formRef.current) {
            await formRef.current.onSubmit();
        }
    }

    const TempNoteForm = ({form, noteLength, isNoteRequired, defaultValue="", placeholder=""})=>{
        return (
            <Form
                layout="vertical"
                form={form}
                initialValues={{ note: defaultValue }}
            >
                <Form.Item label="Note"
                    rules={[{
                        required: isNoteRequired,
                        message: "A note is required",
                        whitespace: true
                    },{
                        max:noteLength, message:`Maximum length is ${noteLength} characters`
                    }]}
                    name="note"
                >
                    <MessageEditor
                        alwaysOpen = {true}
                        placeholder = {placeholder}
                        maxLimit= {1000}
                        mention = {true}
                        uploadBtn = {false}
                        allowCodeSnippet = {false}
                        onChange = {_.noop}
                        showFooterButtons={false}
                        toolBarIdentifier = {'toolBar'}
                        users = {props.users}
                        submitText= {'N/A'}
                        hideEmoji= {true}
                        hideOldUpload= {true}
                        content= {antiTransformComment(defaultValue)}
                        onSubmit= {props.onOk}
                        ref={formRef}
                    />
                </Form.Item>
            </Form>
        )
    }
    
    return (
        <ConfirmPopup
            okText={props.okText}
            title={props.title}
            type={null}
            note
            noteLength={props.noteLength}
            onOk={onOkSubmit}
            defaultValue={props.defaultValue}
            afterClose={props.afterClose}
            NoteForm={TempNoteForm}
            ref={ref}
        />
    )
})